define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function justifyLine(_a) {
        var ctx = _a.ctx, line = _a.line, spaceWidth = _a.spaceWidth, spaceChar = _a.spaceChar, width = _a.width;
        var text = line.trim();
        var words = text.split(/\s+/);
        var numOfWords = words.length - 1;
        if (numOfWords === 0)
            return text;
        var lineWidth = ctx.measureText(words.join('')).width;
        var noOfSpacesToInsert = (width - lineWidth) / spaceWidth;
        var spacesPerWord = Math.floor(noOfSpacesToInsert / numOfWords);
        if (noOfSpacesToInsert < 1)
            return text;
        var spaces = spaceChar.repeat(spacesPerWord);
        return words.join(spaces);
    }
    exports.default = justifyLine;
});
//# sourceMappingURL=DirectiveJustify.js.map